// Reveal-on-scroll: fade + rise, once per element. Respects reduced motion.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = document.querySelectorAll(
    '.sg-reveal, .collection-list .card-wrapper, .featured-collection .card-wrapper, .sg-faq__list, .sg-story__copy'
  );
  if (!targets.length || !('IntersectionObserver' in window)) return;

  targets.forEach((el) => el.classList.add('sg-reveal'));

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (!entry.isIntersecting) return;
        setTimeout(() => entry.target.classList.add('sg-in'), Math.min(i * 70, 280));
        io.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
  );

  targets.forEach((el) => io.observe(el));
})();
